import NavBar from "../components/navbar";
import Card from "../components/card";
import Footer from "../components/footer";
import { useNavigate } from "react-router-dom";

function JobsIntership() {
    let navigate = useNavigate();
    return (
        <div className="flex flex-col h-screen justify-between">
            <NavBar />
            <div className="text-3xl w-64 md:w-full flex flex-col md:flex-row justify-center self-center">
                <Card name="nsa_systems_engineer" title="NSA: Systems Engineer" url="https://apply.intelligencecareers.gov/job-description/1191298" image={require("../images/job-nsa-seal.png")} text="Closes October 14th"/>
                <Card name="fbi_internship" title="FBI: Honors Internship Program" url="https://fbijobs.gov/students-and-interns?utm_source=LinkedIn&utm_medium=Social&utm_campaign=HIP_OrganicLI&utm_content=HIP_JP3" image={require("../images/FBIJobsLogo_Gold.png")} text="2023 closed, start 2024 preparations"/>
            </div>
            <div className="justify-center self-center"><span className="underline cursor-pointer" onClick={() => {navigate("/")}}>Go Back</span></div>
            <Footer />
        </div>
    );
}

export default JobsIntership;
